import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_CON003_Request,
  IAPI_CON003_Response,
} from "../../../type/apiType";

// 申請職員名簿一覧参照API
const httpIAPI_CON003 = async (
  param: IAPI_CON003_Request
): Promise<IAPI_CON003_Response> => {
  let res = await http.post(ApiUrl.API_CON003, {
    ...param,
  });

  return res.data;
};

export { httpIAPI_CON003 };
